import React from "react"
import { Flex, Text, Button } from "@capioweb/ui-components/src"
import { BlockCommonLayout } from "../../utils/layout"
import { urlIsInternal } from "../../utils"
import { StringProperty } from "../../@types/EpiFoundationSpa/Property"

type TagLink = {
	header: string
	url: string
}

export interface CapioNexusTagLinksBlockProps {
	heading: StringProperty
	links: TagLink[]
}

const CapioNexusTagLinksBlock: React.FC<CapioNexusTagLinksBlockProps> = ({
	links,
	...rest
}) => {
	return (
		<BlockCommonLayout {...rest}>
			<Flex
				justifyContent="center"
				flexWrap="wrap"
				columnGap={{ _: 2, m: 3 }}
				rowGap={{ _: 2, m: 3 }}
			>
				{links.map((link, i) =>
					urlIsInternal(link.url) ? (
						<Button.Link to={link?.url ?? "#"} variant="ghost" key={link.header + i}>
							{link.header}
						</Button.Link>
					) : (
						<Button.Anchor href={link.url} variant="ghost" key={link.header + i}>
							{link.header}
						</Button.Anchor>
					)
				)}
			</Flex>
		</BlockCommonLayout>
	)
}

export { CapioNexusTagLinksBlock }
